import type { PengembanganKompetensiV2AspectKey } from 'types/kinerja-ps-pegawai'

export const PENGEMBANGAN_KOMPETENSI_HINTS: Array<string> = [
  'Hasil Refleksi Kompetensi Anda (jika ada)',
  'Hasil diskusi bersama Tim Kinerja tentang fokus dan kemampuan selama 6 bulan ke depan',
]

export const PENGEMBANGAN_KOMPETENSI_ASPECT_LABELS: Record<string, string> = {
  pemantauan: 'Pemantauan',
  penilaian: 'Penilaian',
  pembinaan: 'Pembinaan',
}

export const PENGEMBANGAN_KOMPETENSI_ASPECT_INDICATORS: Record<
  PengembanganKompetensiV2AspectKey,
  Record<string, string[]>
> = {
  pemantauan: {
    muda: [
      'Memantau penerapan nilai moral, etika, dan spiritual guru dalam pelaksanaan pembelajaran.',
      'Mengamati pelaksanaan refleksi guru terhadap proses dan hasil pembelajaran untuk pengembangan kompetensi.',
      'Memantau kolaborasi guru dengan rekan sejawat dan pemangku kepentingan dalam peningkatan mutu pembelajaran.',
    ],
    madya: [
      'Melakukan pemantauan terhadap penerapan pengawasan akademik dalam pelaksanaan pembelajaran mendalam yang berpusat pada murid untuk memperoleh data tentang pelaksanaan proses pembelajaran.',
      'Melakukan pemantauan terhadap penerapan kolaborasi dan keterlibatan pemangku kepentingan dalam peningkatan proses pembelajaran mendalam.',
    ],
    utama: [
      'Melakukan pemantauan terhadap penerapan pengawasan akademik dalam pelaksanaan pembelajaran yang berpusat pada peserta didik.',
      'Memantau penerapan kolaborasi dan keterlibatan pemangku kepentingan dalam peningkatan proses pembelajaran mendalam.',
    ],
  },

  penilaian: {
    muda: [
      'Menilai kesesuaian perilaku profesional guru dengan kode etik dan standar kompetensi guru.',
      'Mengevaluasi efektivitas tindak lanjut hasil refleksi guru terhadap proses dan hasil pembelajaran, kolaborasi guru dengan rekan sejawat dan pemangku kepentingan, dan pengembangan kompetensi guru terhadap hasil belajar murid.',
      'Menilai keterlaksanaan pengawasan akademik dan implementasi kebijakan pendidikan dalam pembelajaran mendalam.',
    ],
    madya: [
      'Melakukan penilaian terhadap perilaku guru dalam menunjukkan kematangan moral, emosi, dan spiritual sesuai kode etik guru.',
      'Melakukan penilaian terhadap penerapan pengembangan kompetensi guru melalui kebiasaan refleksi hasil pembelajaran.',
      'Melakukan penilaian terhadap hasil pelaksanaan pengawasan akademik dan implementasi kebijakan pendidikan untuk peningkatan pembelajaran mendalam.',
    ],
    utama: [
      'Melakukan penilaian terhadap perilaku guru dalam menunjukkan kematangan moral, emosi, dan spiritual sesuai kode etik guru.',
      'Menilai penerapan pengembangan diri guru melalui refleksi hasil pembelajaran.',
      'Mengevaluasi hasil pengawasan akademik dan implementasi kebijakan pendidikan untuk peningkatan proses pembelajaran mendalam.',
    ],
  },

  pembinaan: {
    muda: [
      'Membina guru dalam penguatan nilai-nilai moral, etika profesi, dan tanggung jawab pembelajaran.',
      'Membimbing guru dalam melakukan refleksi dan tindak lanjut untuk peningkatan kualitas pembelajaran.',
      'Mendorong dan memfasilitasi kolaborasi serta pengembangan profesional guru secara berkelanjutan.',
    ],
    madya: [
      'Melakukan pembinaan dan pembimbingan terhadap pelaksanaan tugas Pengawas Sekolah Ahli Muda agar mampu melaksanakan fungsi supervisi akademik secara efektif.',
      'Memberikan umpan balik dan arahan kepada guru dalam meningkatkan kualitas pembelajaran berdasarkan hasil pemantauan dan penilaian.',
    ],
    utama: [
      'Melakukan pembinaan dan pembimbingan terhadap pelaksanaan tugas Pengawas Sekolah Ahli Muda dan Pengawas Ahli Madya agar mampu melaksanakan fungsi supervisi akademik dengan baik.',
      'Memberikan umpan balik dan pendampingan kepada guru untuk meningkatkan kualitas pembelajaran berdasarkan hasil pemantauan dan penilaian.',
    ],
  },
}
